import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { AllowAccess } from "../BlockAccess";
import Button from "../button/Button";
import Icon from "../icon/Icon";
import { loginData, orderData, transactionData } from "./TableData";

export const SpecialTable = ({ action, isCompact, data }) => {
  // console.log(action);
  const DropdownTrans = () => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
          <Icon name="more-h"></Icon>
        </DropdownToggle>
        <DropdownMenu right>
          <ul className="link-list-plain">
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                View
              </DropdownItem>
            </li>
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                Invoice
              </DropdownItem>
            </li>
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                Print
              </DropdownItem>
            </li>
          </ul>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  return (
    <table className={`table table-tranx ${isCompact ? "is-compact" : ""}`}>
      <thead>
        <tr className="tb-tnx-head">
          <th className="tb-tnx-id">
            <span className="">#</span>
          </th>
          <th className="tb-tnx-info">
            <span className="tb-tnx-desc d-none d-sm-inline-block">
              <span>Bill For</span>
            </span>
            <span className="tb-tnx-date d-md-inline-block d-none">
              <span className="d-md-none">Date</span>
              <span className="d-none d-md-block">
                <span>Issue Date</span>
                <span>Due Date</span>
              </span>
            </span>
          </th>
          <th className="tb-tnx-amount is-alt">
            <span className="tb-tnx-total">Total</span>
            <span className="tb-tnx-status d-none d-md-inline-block">Status</span>
          </th>
          {action && (
            <th className="tb-tnx-action">
              <span>&nbsp;</span>
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {data
          ? data.map((item) => {
              return (
                <tr key={item.id} className="tb-tnx-item">
                  <td className="tb-tnx-id">
                    <a
                      href="#id"
                      onClick={(ev) => {
                        ev.preventDefault();
                      }}
                    >
                      <span>{item.id}</span>
                    </a>
                  </td>
                  <td className="tb-tnx-info">
                    <div className="tb-tnx-desc">
                      <span className="title">{item.bill}</span>
                    </div>
                    <div className="tb-tnx-date">
                      <span className="date">{item.issue}</span>
                      <span className="date">{item.due}</span>
                    </div>
                  </td>
                  <td className="tb-tnx-amount is-alt">
                    <div className="tb-tnx-total">
                      <span className="amount">${item.total}</span>
                    </div>
                    <div className="tb-tnx-status">
                      <span
                        className={`badge badge-dot badge-${
                          item.status === "Paid" ? "success" : item.status === "Due" ? "warning" : "danger"
                        }`}
                      >
                        {item.status}
                      </span>
                    </div>
                  </td>

                  {action && (
                    <td className="tb-tnx-action">
                      <DropdownTrans />
                    </td>
                  )}
                </tr>
              );
            })
          : transactionData.data.map((item) => {
              return (
                <tr key={item.id} className="tb-tnx-item">
                  <td className="tb-tnx-id">
                    <a
                      href="#id"
                      onClick={(ev) => {
                        ev.preventDefault();
                      }}
                    >
                      <span>{item.id}</span>
                    </a>
                  </td>
                  <td className="tb-tnx-info">
                    <div className="tb-tnx-desc">
                      <span className="title">{item.bill}</span>
                    </div>
                    <div className="tb-tnx-date">
                      <span className="date">{item.issue}</span>
                      <span className="date">{item.due}</span>
                    </div>
                  </td>
                  <td className="tb-tnx-amount is-alt">
                    <div className="tb-tnx-total">
                      <span className="amount">${item.total}</span>
                    </div>
                    <div className="tb-tnx-status">
                      <span
                        className={`badge badge-dot badge-${
                          item.status === "Paid" ? "success" : item.status === "Due" ? "warning" : "danger"
                        }`}
                      >
                        {item.status}
                      </span>
                    </div>
                  </td>

                  {action && (
                    <td className="tb-tnx-action">
                      <DropdownTrans />
                    </td>
                  )}
                </tr>
              );
            })}
      </tbody>
    </table>
  );
};

export const OrderTable = () => {
  const DropdownTrans = () => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
          <Icon name="more-h"></Icon>
        </DropdownToggle>
        <DropdownMenu right>
          <ul className="link-list-plain">
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                View
              </DropdownItem>
            </li>
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                Invoice
              </DropdownItem>
            </li>
            <li>
              <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                }}
              >
                Print
              </DropdownItem>
            </li>
          </ul>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th className="tb-odr-info">
            <span className="tb-odr-id">Order ID</span>
            <span className="tb-odr-date d-none d-md-inline-block">Date</span>
          </th>
          <th className="tb-odr-amount">
            <span className="tb-odr-total">Amount</span>
            <span className="tb-odr-status d-none d-md-inline-block">Status</span>
          </th>
          <th className="tb-odr-action">&nbsp;</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {orderData.map((item) => {
          return (
            <tr className="tb-odr-item" key={item.id}>
              <td className="tb-odr-info">
                <span className="tb-odr-id">
                  <a
                    href="#id"
                    onClick={(ev) => {
                      ev.preventDefault();
                    }}
                  >
                    {item.id}
                  </a>
                </span>
                <span className="tb-odr-date">{item.date}</span>
              </td>
              <td className="tb-odr-amount">
                <span className="tb-odr-total">
                  <span className="amount">${item.amount}</span>
                </span>
                <span className="tb-odr-status">
                  <span
                    className={`badge badge-dot badge-${
                      item.status === "Complete" ? "success" : item.status === "Pending" ? "warning" : "danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </span>
              </td>
              <td className="tb-odr-action">
                <div className="tb-odr-btns d-none d-md-inline">
                  <Button color="primary" className="btn-sm">
                    View
                  </Button>
                </div>
                <DropdownTrans />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const ProductTable = ({ product, onEditClick, handleView }) => {
  return (
    <table className="table table-borders">
      <thead className="tb-odr-head table-dark">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Product Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {product &&
          product.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdDate ? item.createdDate : "N/A"}</td>
                <td style={{ maxWidth: "10rem" }}>{item.productName}</td>
                <td style={{ maxWidth: "10rem" }}>
                  {item.productDescription.split(".").map((parag) => (
                    <p>{parag}</p>
                  ))}
                </td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>

                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_PRODUCT"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_PRODUCT"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const TenorTable = ({ productTenor, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Tenor Name</th>
          <th>Description</th>
          <th>Days</th>
          <th>Months</th>
          <th>Years</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {productTenor &&
          productTenor.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdDate ? item.createdDate : "N/A"}</td>
                <td>{item.tenorName}</td>
                <td>{item.tenorDescription}</td>
                <td>{item.tenorDays}</td>
                <td>{item.tenorMonths}</td>
                <td>{item.tenorYears}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.tenorStatus === "ACTIVE" ? "success" : "danger"}`}>
                    {item.tenorStatus}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_TENOR"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const WithDrawalreasonTable = ({ WithdrawalReason, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Reason</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {WithdrawalReason &&
          WithdrawalReason.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdDate ? item.createdDate : "N/A"}</td>
                <td>{item.reason}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_WITHDRAWAL_REASON"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["DELETE_WITHDRAWAL_REASON"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="danger"
                        className="btn-sm mt-2"
                        onClick={() => handleDel(item)}
                      >
                        Delete
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ReferralRewardsTable = ({ data, onEditClick, onDeleteClick, products }) => {
  const getPlanName = (targetPlanId) =>
    products?.find((prod) => prod.id === targetPlanId)?.productName ?? targetPlanId ?? "N/A";

  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Created Date</th>
          <th>Referral Status</th>
          <th>Reward Type</th>
          <th>Target Plan</th>
          <th>Value</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdAt ?? "N/A"}</td>
                <td>
                  <span className="badge badge-dot badge-info">{item?.referralStatus ?? "N/A"}</span>
                </td>
                <td>{item?.rewardType ?? "N/A"}</td>
                <td>{getPlanName(item?.targetPlanId)}</td>
                <td>{item?.rewardType === "PERCENTAGE" ? `${item?.value}%` : item?.value ?? "N/A"}</td>
                <td className="">
                  <div>
                    <Button
                      style={{ width: "8em", display: "flex", justifyContent: "center" }}
                      color="warning"
                      className="btn-sm"
                      onClick={() => onEditClick(item)}
                    >
                      Edit
                    </Button>
                    <Button
                      style={{ width: "8em", display: "flex", justifyContent: "center" }}
                      color="danger"
                      className="btn-sm mt-2"
                      onClick={() => onDeleteClick(item)}
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const WithholdingTaxTable = ({ WithholdingTax, onEditClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Rate</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {WithholdingTax &&
          WithholdingTax.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.rate}</td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_WITHHOLDING_TAX_RATE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const GenderTable = ({ Gender, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Gender</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {Gender &&
          Gender.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.gender}</td>
                <td>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_GENDER"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const SourceTable = ({ Source, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Source</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {Source &&
          Source.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_SOURCE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const IdentificationTypeTable = ({ IdentificationType, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {IdentificationType &&
          IdentificationType.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_IDENTIFICATION_TYPE"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const WalletTransactionsTable = ({ WalletTransactions, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Recipient</th>
          <th>Date Added</th>
          <th>Transaction Type</th>
          <th>Transaction Amount</th>
          <th>Transaction Category</th>
          <th>Transaction Description</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {WalletTransactions &&
          WalletTransactions.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.useraccount.email}</td>
                <td>{item.createdDate ? item.createdAt : "N/A"}</td>
                <td>{item.transactionType}</td>
                <td>{item.amount}</td>
                <td>{item.transactionCategory}</td>
                <td>{item.transactionDescription}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const WalletManagementTable = ({
  totalAmount,
  handleCustomerWalletBalance,
  handleReferralSettings,
  handleSpecialEarning,
}) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Total Wallet Amount</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        <tr>
          <td>{totalAmount.toLocaleString("en-US")}</td>
          <td>
            <Button
              style={{ width: "14em", display: "flex", justifyContent: "center" }}
              color="primary"
              className="btn-sm"
              onClick={() => handleCustomerWalletBalance()}
            >
              Customer Wallet Balance
            </Button>
            <br />
            <br />
            <Button
              style={{ width: "14em", display: "flex", justifyContent: "center" }}
              color="primary"
              className="btn-sm"
              onClick={() => handleReferralSettings()}
            >
              Referral Bonus Settings
            </Button>
            <br />
            <br />
            <Button
              style={{ width: "14em", display: "flex", justifyContent: "center" }}
              color="primary"
              className="btn-sm"
              onClick={() => handleSpecialEarning()}
            >
              Special Earning Payout
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const ProductCategoryTable = ({ productCate, onEditClick, handleView, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Product Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {productCate &&
          productCate.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdDate ? item.createdDate : "N/A"}</td>
                <td>{item.name}</td>
                <td style={{ maxWidth: "200px" }}>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_PRODUCT_CATEGORY"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_PRODUCT_CATEGORY"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const InvestmentRateTable = ({ investRate, onEditClick, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Product Name</th>
          <th>Currency</th>
          <th>Min Amount</th>
          <th>Max Amount</th>
          <th>Min Tenor</th>
          <th>Max Tenor</th>
          {/* <th>Currency</th> */}
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {investRate &&
          investRate.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.product.productName}</td>
                <td>{item.currency.name}</td>
                <td>{item.minimumAmount}</td>
                <td>{item.maximumAmount}</td>
                <td>{item.minimumTenor}</td>
                <td>{item.maximumTenor}</td>
                {/* <td>{item.currency}</td> */}
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div className="">
                    <AllowAccess allowedRights={["EDIT_INVESTMENT_RATE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_INVESMENT_RATE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ProductPropertyTable = ({ productProperty, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Property Name</th>
          <th>Date Added</th>
          <th>Description</th>
          <th>Abilities</th>
          <th>System Impacts</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {productProperty &&
          productProperty.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.productName}</td>
                <td>{item.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.minDaysElapsed}</td>
                <td>{item.maxDaysElapsed}</td>
                <td>{item.penalRate}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const PenalChargeTable = ({ PenalRate, onEditClick, handleEdit, handleView, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Product Name</th>
          <th>Min Days Elapse</th>
          <th>Max Days Elapse</th>
          <th> Rate</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {PenalRate &&
          PenalRate.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.product ? <>{item.product.productName}</> : null}</td>
                <td>{item.minDaysElapsed}</td>
                <td>{item.maxDaysElapsed}</td>
                <td>{item.penalRate}</td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_PENAL_CHARGE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const WithholdingRateTable = ({ WithholdingRate, onEditClick, handleEdit, handleView, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Product Name</th>
          <th>Date Added</th>
          <th>Min Days Elapse</th>
          <th>Max Days Elapse</th>
          <th> Rate</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {WithholdingRate &&
          WithholdingRate.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.productName}</td>
                <td>{item?.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.minDaysElapsed}</td>
                <td>{item.maxDaysElapsed}</td>
                <td>{item.penalRate}</td>
                <td className="">
                  <div className="tb-odr-btns d-none d-md-inline">
                    <Button
                      color="warning"
                      style={{ width: "8em", display: "flex", justifyContent: "center" }}
                      className="btn-sm"
                      onClick={() => onEditClick(item)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="danger"
                      style={{ width: "8em", display: "flex", justifyContent: "center" }}
                      className="btn-sm mt-2"
                      onClick={() => handleDel(item)}
                    >
                      Delete
                    </Button>
                  </div>
                  {/* <DropdownTrans /> */}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const CurrencyManageTable = ({ currencyMge, handleEdit, handleView, onEditClick, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Currency Name</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {currencyMge &&
          currencyMge.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.name}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_CURRENCY"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    {/**   <Button
                  color="danger"
                  style={{ width: "8em", display: "flex", justifyContent: "center" }}
                  className="btn-sm mt-2"
                  onClick={() => handleDel(item)}
                >
                  Delete
                </Button>*/}
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ExchangeRateTable = ({ exchangeRate, onEditClick, handleEdit, handleView, handleDel }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Currency</th>
          <th>Buying Price</th>
          <th>Selling Price</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {exchangeRate &&
          exchangeRate.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.name}</td>
                <td>{item.buyingPrice}</td>
                <td>{item.sellingPrice}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_EXCHANGE_RATE"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["DELETE_EXCHANGE_RATE"]}>
                      <Button
                        color="danger"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleDel(item)}
                      >
                        Delete
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ProcessStageTable = ({ processStage, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Stage Name</th>
          <th>Role</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {processStage &&
          processStage.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.stageName}</td>
                <td>{item.role.roleName}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_STAGE"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ProcessTable = ({ process, handleOnclick, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Process Name</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {process &&
          process.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.processName}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_PROCESS_FLOW"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_PROCESS_FLOW"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const TicketTable = ({
  data,
  handleOnclick,
  onEditClick,
  handleEdit,
  handleView,
  handleReopenTicket,
  handleCloseTicket,
}) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Customer Name</th>
          <th>Feedback Category</th>
          <th>Feedback Title</th>
          <th>Number of Responses</th>
          <th>Status</th>
          <th>Date Updated</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item?.company?.name ?? item?.customerName}</td>
                <td>{item?.category?.name ?? "N/A"}</td>
                <td>{item?.title ?? "N/A"}</td>
                <td>{item?.numberOfResponses}</td>
                <td>
                  <span className={`badge badge-dot badge-${item?.status === "OPENED" ? "success" : "danger"}`}>
                    {item?.status === "OPENED" ? "OPEN" : item?.status}
                  </span>
                </td>
                <td>{item.modifiedAt}</td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["VIEW_TICKET"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                    {item.status === "CLOSED" ? (
                      <AllowAccess allowedRights={["REOPEN_TICKET"]}>
                        <Button
                          color="warning"
                          style={{ width: "8em", display: "flex", justifyContent: "center" }}
                          className="btn-sm mt-2"
                          onClick={() => handleReopenTicket(item)}
                        >
                          ReOpen
                        </Button>
                      </AllowAccess>
                    ) : (
                      <AllowAccess allowedRights={["CLOSE_TICKET"]}>
                        <Button
                          color="danger"
                          style={{ width: "8em", display: "flex", justifyContent: "center" }}
                          className="btn-sm mt-2"
                          onClick={() => handleCloseTicket(item)}
                        >
                          Close
                        </Button>
                      </AllowAccess>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};
export const MyCustomersTable = ({ data, onViewClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Created</th>
          <th>Customer ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Company Name</th>
          <th>Email</th>
          <th>Source</th>
          <th>Creation Source</th>
          <th>Type</th>
          <th>Account Officer</th>
          <th>Business Unit</th>
          <th>NUBAN Number</th>
          <th>Investment Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item?.id}>
                <td style={{ minWidth: "12rem" }}>{item?.createdAt ? item.createdAt : "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.individualUser?.id ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.individualUser?.firstName ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.individualUser?.lastName ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.company?.name ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.email ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.source ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.creationSource ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.role ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.accountOfficerName ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.businessUnit?.name ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.nuban ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td style={{ minWidth: "10rem" }} className="">
                  {/* <AllowAccess allowedRights={[""]}> */}
                  <div>
                    <Button
                      color="primary"
                      style={{ width: "8em", display: "flex", justifyContent: "center" }}
                      className="btn-sm"
                      onClick={() => onViewClick(item)}
                    >
                      View
                    </Button>
                  </div>
                  {/* </AllowAccess> */}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const MyReferralsTable = ({ data }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Created</th>
          <th>Referral ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Last Login</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item?.id}>
                <td style={{ minWidth: "12rem" }}>{item?.createdAt ? item.createdAt : "N/A"}</td>
                <td style={{ minWidth: "8rem" }}>{item?.id ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.firstName ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.lastName ?? "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>{item?.lastLogin ? item.lastLogin : "N/A"}</td>
                <td style={{ minWidth: "10rem" }}>
                  <span
                    className={`badge badge-dot badge-${
                      item.referralStatus === "REGISTERED" ? "success" : "warning"
                    }`}
                  >
                    {item.referralStatus ?? "N/A"}
                  </span>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const TicketCategoryTable = ({ data, handleOnclick, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_TICKET_CATEGORY"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const FaqCategoryTable = ({ data, handleOnclick, onDeleteClick, onEditClick, handleEdit, onViewClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.dateAdded ? item.dateAdded : "N/A"}</td>
                <td>{item.name}</td>
                <td style={{ maxWidth: "250px" }}>{item.description}</td>
                <td>
                  <span
                    className={`badge badge-dot badge-${
                      item.status === "Active" || item.status === "ACTIVE" ? "success" : "danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_FAQ_CATEGORY"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>

                    <AllowAccess allowedRights={["DELETE_FAQ_CATEGORY"]}>
                      <Button
                        color="danger"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => onDeleteClick(item)}
                      >
                        Delete
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const MessageTable = ({ data, handleOnclick, onEditClick, handleEdit, onViewClick, handleDelete }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Title / Subject</th>
          {/* <th>Description</th> */}
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.dateCreated ? item.dateCreated : "N/A"}</td>
                <td>{item.title}</td>
                {/* <td>{item.description}</td> */}
                <td>
                  <span
                    className={`badge badge-dot badge-${
                      item.status === "SENT" || item.status === "Sent"
                        ? "success"
                        : item.status === "PENDING"
                        ? "warning"
                        : "danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["VIEW_MESSAGE"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onViewClick(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["EDIT_MESSAGE"]}>
                      {item?.status !== "SENT" && (
                        <Button
                          color="warning"
                          style={{ width: "8em", display: "flex", justifyContent: "center" }}
                          className="btn-sm mt-2"
                          onClick={() => onEditClick(item)}
                        >
                          Edit
                        </Button>
                      )}
                    </AllowAccess>
                    <AllowAccess allowedRights={["DELETE_MESSAGE"]}>
                      <Button
                        color="danger"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleDelete(item?.id)}
                      >
                        Delete
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ReportTable = ({ data, reportType, reportTypeEnum }) => {
  const renderStageContent = (stage) => {
    if (!stage) return "N/A";

    return (
      <div className="stage-content">
        <p>
          <strong>Stage Name:</strong> {stage?.stageName ?? "N/A"}
        </p>
        <p>
          <strong>Staff Name:</strong> {stage?.staffName ?? "N/A"}
        </p>
        <p>
          <strong>Created Date:</strong> {stage?.createdAt ?? "N/A"}
        </p>
         <p>
          <strong>Department That Treated :</strong> {stage?.departmentThatTreated ?? "N/A"}
        </p>
        <p>
          <strong>Action:</strong> {stage?.endAction ?? "N/A"}
        </p>
        <p>
          <strong>Comment:</strong> {stage?.staffComment ?? "-"}
        </p>

      </div>
    );
  };

  // Function to expand TAT_REPORT rows based on stages
  const expandTATRows = (data) => {
    const expandedData = [];

    data.forEach((item) => {
      if (item?.withdrawalRequestAuditTrail && item.withdrawalRequestAuditTrail.length > 0) {
        // Sort stages by createdAt date for each transaction
        const sortedStages = [...item.withdrawalRequestAuditTrail].sort((a, b) => {
          // Parse the date strings (format: "DD-MM-YYYY HH:mm AM/PM")
          const dateA = new Date(a.createdAt.replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1"));
          const dateB = new Date(b.createdAt.replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1"));
          return dateA - dateB;
        });

        // Create a row for each stage in chronological order
        sortedStages.forEach((stage) => {
          expandedData.push({
            ...item,
            currentStage: stage,
          });
        });
      } else {
        // If no stages, add one row with no stage data
        expandedData.push({
          ...item,
          currentStage: null,
        });
      }
    });

    return expandedData;
  };

  // Prepare data for TAT_REPORT
  const displayData = reportType === reportTypeEnum.TAT_REPORT ? expandTATRows(data) : data;

  const headerStyle = {
    whiteSpace: "nowrap",
    padding: "12px 20px",
    minWidth: "150px",
    fontWeight: "600",
    fontSize: "14px",
    borderRight: "1px solid #e5e7eb"
  };

  const cellStyle = {
    padding: "12px 20px",
    minWidth: "150px",
    borderRight: "1px solid #f3f4f6"
  };

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <table className="table table-orders" style={{ borderCollapse: "collapse" }}>
        <thead className="tb-odr-head">
          <tr className="tb-odr-item">
            {reportType === reportTypeEnum.TRANSACTION && (
              <>
                <th style={headerStyle}>Transaction Date</th>
                <th style={headerStyle}>Transaction ID</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Product</th>
                <th style={headerStyle}>Transaction Amount</th>
                <th style={headerStyle}>Transaction Type</th>
                <th style={headerStyle}>Transaction Description</th>
                <th style={headerStyle}>DR Account / Plan</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>CR Account / Plan</th>
              </>
            )}
            {reportType === reportTypeEnum.INVESTMENT && (
              <>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Customer Email</th>
                <th style={headerStyle}>Phone Number</th>
                <th style={headerStyle}>Product Type</th>
                <th style={headerStyle}>Investment Amount</th>
                <th style={headerStyle}>Interest Rate</th>
                <th style={headerStyle}>Tenor (Days)</th>
                <th style={headerStyle}>Interest Option</th>
                <th style={headerStyle}>Creation Date</th>
                <th style={headerStyle}>Maturity Date</th>
                <th style={headerStyle}>Interest Accrued</th>
                <th style={headerStyle}>Plan Status</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Days Elapsed</th>
              </>
            )}
            {reportType === reportTypeEnum.ACTIVE_CUSTOMERS && (
              <>
                <th style={headerStyle}>Account Officer Name</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>BVN</th>
                <th style={headerStyle}>Date Of Birth</th>
                <th style={headerStyle}>Email Address</th>
                <th style={headerStyle}>Face Value</th>
                <th style={headerStyle}>Interest Rate</th>
                <th style={headerStyle}>Gender</th>
                <th style={headerStyle}>Tenor (Days)</th>
                <th style={headerStyle}>Phone Number</th>
                <th style={headerStyle}>Maturity Date</th>
                <th style={headerStyle}>Outstanding Balance</th>
                <th style={headerStyle}>Effective Date</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Referral Code</th>
              </>
            )}
            {reportType === reportTypeEnum.ADHOC_INVESTMENT && (
              <>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Account Type</th>
                <th style={headerStyle}>Product Name</th>
                <th style={headerStyle}>Interest Rate</th>
                <th style={headerStyle}>Business Unit</th>
                <th style={headerStyle}>Tenor (Days)</th>
                <th style={headerStyle}>Interest Payment Option</th>
                <th style={headerStyle}>Investment Date</th>
                <th style={headerStyle}>Rollover Status</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Account Officer</th>
              </>
            )}
            {reportType === reportTypeEnum.REFERRALS && (
              <>
                <th style={headerStyle}>Registration Date</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Company Type</th>
                <th style={headerStyle}>Source</th>
                <th style={headerStyle}>Referred By (Referral Code)</th>
                <th style={headerStyle}>Investment Status</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Activation Bonus Redeemed</th>
              </>
            )}
            {reportType === reportTypeEnum.INTEREST_EXPENSE && (
              <>
                <th style={headerStyle}>Date</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Plan Name</th>
                <th style={headerStyle}>Investment Balance</th>
                <th style={headerStyle}>Interest Earned</th>
                <th style={headerStyle}>WHT</th>
                <th style={headerStyle}>Interest Payout Amount</th>
                <th style={headerStyle}>Interest Rate</th>
                <th style={headerStyle}>Investment Creation Date</th>
                <th style={headerStyle}>Investment Maturity Date</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Interest Receipt Option</th>
              </>
            )}
            {reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION && (
              <>
                <th style={headerStyle}>Date</th>
                <th style={headerStyle}>Transaction ID</th>
                <th style={headerStyle}>Description</th>
                <th style={headerStyle}>Transaction Type (CR/DR)</th>
                <th style={headerStyle}>Transaction Amount</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Balance</th>
              </>
            )}
            {reportType === reportTypeEnum.CUSTOMER_REGISTRATION && (
              <>
                <th style={headerStyle}>Registration Date</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Status</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Customer Type</th>
                <th style={headerStyle}>Email</th>
                <th style={headerStyle}>Phone Number</th>
                <th style={headerStyle}>State</th>
                <th style={headerStyle}>Gender</th>
                <th style={headerStyle}>BVN</th>
                <th style={headerStyle}>Wema Account Number</th>
                <th style={headerStyle}>KYC Status</th>
                <th style={headerStyle}>Reserved Account Number</th>
                <th style={headerStyle}>Investment Status</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Referral Code</th>
              </>
            )}
            {reportType === reportTypeEnum.CUSTOMER_SOURCE && (
              <>
                <th style={headerStyle}>Registration Date</th>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Customer Type</th>
                <th style={headerStyle}>Channel</th>
                <th style={headerStyle}>Source</th>
                <th style={headerStyle}>Referred by (Referral Code)</th>
                <th style={headerStyle}>Others</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Investment Status</th>
              </>
            )}
            {reportType === reportTypeEnum.CBN_MOM_INVESTMENT && (
              <>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Face Amount</th>
                <th style={headerStyle}>Borrowed Amount</th>
                <th style={headerStyle}>Effective Date</th>
                <th style={headerStyle}>Interest Rate</th>
                <th style={headerStyle}>Tenor</th>
                <th style={headerStyle}>Maturity Date</th>
                <th style={headerStyle}>Interest Amount</th>
                <th style={headerStyle}>Repayment Amount</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>No of Days</th>
              </>
            )}
            {reportType === reportTypeEnum.WALLET_PORTFOLIO && (
              <>
                <th style={headerStyle}>Customer ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Customer Type</th>
                <th style={{ ...headerStyle, borderRight: "none" }}>Wallet Balance</th>
              </>
            )}
            {reportType === reportTypeEnum.TAT_REPORT && (
              <>
                <th style={headerStyle}>Customer Id</th>
                <th style={headerStyle}>Transaction Date</th>
                <th style={headerStyle}>Transaction ID</th>
                <th style={headerStyle}>Customer Name</th>
                <th style={headerStyle}>Withdrawal Amount</th>
                <th style={headerStyle}>Status</th>
                <th style={{ ...headerStyle, borderRight: "none", minWidth: "280px" }}>Stage Details</th>
              </>
            )}
          </tr>
        </thead>
        <tbody className="tb-odr-body">
          {displayData &&
            displayData.map((item, _idx) => {
              return (
                <tr key={_idx}>
                  {reportType === reportTypeEnum.TRANSACTION && (
                    <>
                      <td style={cellStyle}>{item?.transactionDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.transactionId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.product ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.transactionAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.transactionType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.transactionDescription ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.drAccount ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.crAccount ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.INVESTMENT && (
                    <>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerEmail ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerPhone ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.productType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestRate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tenorDays ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestOption ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.creationDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.maturityDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestAccrued?.toFixed(2) ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.planStatus ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.daysElapsed ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.ACTIVE_CUSTOMERS && (
                    <>
                      <td style={cellStyle}>{item?.accountOfficerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.bvn ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.dateOfBirth ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.emailAddress ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.faceValue ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestRate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.gender ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tenorDays ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.phoneNumber ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.maturityDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.outstandingBalance ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.effectiveDate ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.referralCode ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.REFERRALS && (
                    <>
                      <td style={cellStyle}>{item?.registrationDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? item?.companyName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.source ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.referredBy ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentStatus ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.activationBonusRedeemed === true ? "YES" : "NO" ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.ADHOC_INVESTMENT && (
                    <>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerOrCompanyName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.accountType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.productName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestRate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.businessUnit ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tenor ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestPaymentOption ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.rolloverStatus ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.accountOfficer ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.INTEREST_EXPENSE && (
                    <>
                      <td style={cellStyle}>{item?.date ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.planName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentBalance ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestEarned ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.wht?.toFixed(2) ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestPayoutAmount?.toFixed(2) ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestRate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentCreationDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentMaturityDate ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.interestOption ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION && (
                    <>
                      <td style={cellStyle}>{item?.dateOfTransaction ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tranId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.description ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tranType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tranAmount ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.balance ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.CUSTOMER_REGISTRATION && (
                    <>
                      <td style={cellStyle}>{item?.registrationDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.status ?? "N/A"}</td>
                      <td style={cellStyle}>
                        {item?.firstName || item?.lastName
                          ? `${item?.firstName ?? ""} ${item?.lastName ?? ""}`
                          : item?.companyName ?? "N/A"}
                      </td>
                      <td style={cellStyle}>{item?.customerType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.email ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.phoneNumber ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.state ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.gender ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.bvn ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.wemaAccountNumber ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.kycStatus ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.reservedAccountNumber ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.investmentStatus ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.referralCode ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.CUSTOMER_SOURCE && (
                    <>
                      <td style={cellStyle}>{item?.registrationDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? item?.companyName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerType ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.registrationChannel ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.source ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.referredBy ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.others ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.investmentStatus ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.CBN_MOM_INVESTMENT && (
                    <>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? item?.companyName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.faceAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.borrowedAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.effectiveDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestRate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.tenor ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.maturityDate ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.interestAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.repaymentAmount ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.noOfDays ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.WALLET_PORTFOLIO && (
                    <>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerType ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none" }}>{item?.walletBalance ?? "N/A"}</td>
                    </>
                  )}
                  {reportType === reportTypeEnum.TAT_REPORT && (
                    <>
                      <td style={cellStyle}>{item?.customerId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.createdAt ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.transactionId ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.customerName ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.withdrawalAmount ?? "N/A"}</td>
                      <td style={cellStyle}>{item?.currentStatus ?? "N/A"}</td>
                      <td style={{ ...cellStyle, borderRight: "none", minWidth: "280px" }}>{renderStageContent(item?.currentStage)}</td>
                    </>
                  )}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export const FaqTable = ({ data, handleOnclick, onEditClick, handleEdit, onViewClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>FAQ Category</th>
          <th>Question</th>
          <th>Date Updated</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.faqCategory.name}</td>
                <td>{item.question}</td>
                <td>{item.dateUpdated ? item.dateUpdated : "N/A"}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_FAQ"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_FAQ"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => onViewClick(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const PendingRequestsTable = ({ data, onViewClick, isQueue }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Request Date</th>
          <th>Request ID</th>
          <th>Customer ID</th>
          <th>Customer Name</th>
          <th>Request Type</th>
          <th>Plan Name</th>
          {/* <th>Product</th> */}
          {!isQueue && <th>last Action Date</th>}
          <th>Approval Required</th>
          <th>Requester</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {data &&
          data?.map((item) => {
            return (
              <tr key={item.id}>
                <td className={{ minWidth: "14rem" }}>{item?.requestDate ? item.requestDate : "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>{item?.requestId ? item.requestId : "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>{item?.requester?.customerId ?? "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>{item?.customerName}</td>
                <td className={{ minWidth: "14rem" }}>{item?.requestType ?? "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>{item?.plan?.planName ?? "N/A"}</td>
                {/* <td className={{ minWidth: "14rem" }}>{item?.product?.productName ?? "N/A"}</td> */}
                {!isQueue && <td className={{ minWidth: "14rem" }}>{item?.lastActionDate ?? "N/A"}</td>}
                <td className={{ minWidth: "14rem" }}>{item?.departmentToApprove?.roleName ?? "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>{item?.customerName ?? "N/A"}</td>
                <td className={{ minWidth: "14rem" }}>
                  <div>
                    {isQueue ? (
                      <AllowAccess allowedRights={["TREAT_REQUEST"]}>
                        <Button
                          color="primary"
                          style={{ width: "8em", display: "flex", justifyContent: "center" }}
                          className="btn-sm"
                          onClick={() => onViewClick(item)}
                        >
                          Treat Request
                        </Button>
                      </AllowAccess>
                    ) : (
                      <AllowAccess allowedRights={["VIEW_REQUEST"]}>
                        <Button
                          color="primary"
                          style={{ width: "8em", display: "flex", justifyContent: "center" }}
                          className="btn-sm mt-2"
                          onClick={() => onViewClick(item)}
                        >
                          View
                        </Button>
                      </AllowAccess>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const MangeUserTable = ({ adminUsers, onEditClick, handleEdit, handleView, onViewClick, onResetClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th style={{ maxWidth: "8em" }}>Referral Code</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {adminUsers &&
          adminUsers.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ?? "N/A"}</td>
                <td>{item.contactName}</td>
                <td style={{ maxWidth: "10em" }}>{item.email}</td>
                <td>{item.assignedRole?.roleName}</td>
                <td style={{ maxWidth: "8em" }}>{item.myReferralCode ?? "N/A"}</td>
                <td>
                  <span
                    className={`badge badge-dot badge-${
                      item.status === "ACTIVE" ? "success" : item?.status === "LOCKED" ? "gray" : "danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div className="">
                    <AllowAccess allowedRights={["EDIT_ADMIN_USER"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_ADMIN_USER"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        onClick={() => onViewClick(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["RESET_ADMIN_USER"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="danger"
                        className="btn-sm mt-2"
                        onClick={() => onResetClick(item)}
                      >
                        Reset
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ManageRoleTable = ({ managerole, handleOnclick, onEditClick, handleEdit, handleView, onViewClick }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {managerole &&
          managerole.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdAt ? item?.createdAt : "N/A"}</td>
                <td>{item.roleName}</td>
                <td>{item.description}</td>
                <td>
                  <div>
                    <AllowAccess allowedRights={["EDIT_ROLE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_ROLE"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        onClick={() => onViewClick(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const ManageBranchTable = ({ manageBranch, handleOnclick, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {manageBranch &&
          manageBranch.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.name}</td>
                <td style={{ maxWidth: "200px" }}>{item.description}</td>
                <td>
                  <span
                    className={`badge badge-dot badge-${
                      item.status === "Active" || item.status === "ACTIVE" ? "success" : "danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <AllowAccess allowedRights={["EDIT_BRANCH"]}>
                    <div>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </div>
                  </AllowAccess>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const DeptManageTable = ({ manageDepart, handleOnclick, onEditClick, handleEdit, handleView }) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {manageDepart &&
          manageDepart.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item.createdAt ? item.createdAt : "N/A"}</td>
                <td>{item.name}</td>
                <td style={{ maxWidth: "200px" }}>{item.description}</td>
                <td>
                  <span className={`badge badge-dot badge-${item.status === "ACTIVE" ? "success" : "danger"}`}>
                    {item.status}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["EDIT_DEPARTMENT"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="warning"
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const CustomerDashboardTable = ({
  customerDashboard,
  handleOnclick,
  onEditClick,
  onDetailsClick,
  handleView,
  handleInvestment,
}) => {
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Customer ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Company Name</th>
          {/* <th>Source</th> */}
          <th>Creation Source</th>
          <th>Type</th>
          <th>Account Officer</th>
          <th>Business Unit</th>
          <th>NUBAN Number</th>
          <th>Investment Status</th>
          <th>Account Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {customerDashboard &&
          customerDashboard.map((item) => {
            return (
              <tr style={{ fontSize: "0.85em" }} key={item?.id}>
                <td>{item?.createdAt ? item.createdAt : "N/A"}</td>

                <td>{item?.customerId ?? "N/A"}</td>

                <td>{item?.firstName}</td>

                <td>{item?.lastName}</td>

                <td>{item?.companyName ? item.companyName : "N/A"}</td>

                {/* <td>{item?.source}</td> */}

                <td>{item?.creationSource}</td>

                <td>{item?.type}</td>
                <td>{item?.accountOfficer?.accountOfficerName ?? "N/A"}</td>
                <td>{item?.accountOfficer?.businessUnit?.name ?? "N/A"}</td>
                <td>{item?.nuban ?? "N/A"}</td>
                 <td>
                  <span
                    className={`badge badge-dot badge-${item?.investmentStatus === "ACTIVE" ? "success" : "danger"}`}
                  >
                    {item?.investmentStatus}
                  </span>
                </td>
                <td>
                  <span
                    className={`badge badge-dot badge-${item?.accountStatus === "ACTIVE" ? "success" : "danger"}`}
                  >
                    {item?.accountStatus}
                  </span>
                </td>

                <td className="">
                  <div className="">
                    <AllowAccess allowedRights={["EDIT_CUSTOMER"]}>
                      <Button
                        color="warning"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm"
                        onClick={() => onEditClick(item)}
                      >
                        Edit
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["VIEW_CUSTOMER"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleView(item)}
                      >
                        View
                      </Button>
                    </AllowAccess>
                    <AllowAccess allowedRights={["CREATE_INVESTMENT"]}>
                      <Button
                        color="primary"
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        className="btn-sm mt-2"
                        onClick={() => handleInvestment(item)}
                      >
                        Create Investment
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const CustomerInvestmentTable = ({
  onTransferClick,
  customerInvestments,
  onTopUpClick,
  handleTransfer,
  handleWithdraw,
  onWithdrawalClick,
}) => {
//   setInterval(()=>{
// console.log(customerInvestments)
//   },1000)
  return (
    <table className="table table-orders">
      <thead className="tb-odr-head">
        <tr className="tb-odr-item">
          <th>Date Added</th>
          <th>Customer ID</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Product</th>
          <th>Plan Name</th>
          <th>Tenor</th>
          <th>Investment Start Date</th>
          <th>Account Officer</th>
          <th>Business Unit</th>
          <th>Balance</th>
          <th>Investment Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody className="tb-odr-body">
        {customerInvestments &&
          customerInvestments.map((item) => {
            return (
              <tr key={item.id}>
                <td>{item?.createdDate ? item?.createdDate : "N/A"}</td>
                <td>{item?.id}</td>
                <td>{item?.firstName}</td>
                <td>{item?.lastName}</td>
                <td>{item?.product?.productName ?? "N/A"}</td>
                <td>{item?.planName ?? "N/A"}</td>
                <td>{item?.tenor?.tenorName ?? "N/A"}</td>
                <td>{item?.planDate ? item?.planDate : "N/A"}</td>
                <td>{item?.useraccount?.accountOfficerName ?? "N/A"}</td>
                <td>{item?.branch?.name ?? "N/A"}</td>
                <td>{item?.principal ?? "N/A"}</td>
                <td>
                  <span
                    className={`badge badge-dot badge-${
                      item.planStatus === "ACTIVE" ? "success" : item?.planStatus === "PENDING" ? "warning" : "danger"
                    }`}
                  >
                    {item.planStatus}
                  </span>
                </td>
                <td className="">
                  <div>
                    <AllowAccess allowedRights={["TOPUP_INVESTMENT"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm"
                        onClick={() => onTopUpClick(item)}
                        disabled={
                          // !(
                          //   item?.product?.properties?.allowsTopUp &&
                          //   (item?.interestReceiptOption === "MATURITY" ||
                          //     item?.interestReceiptOption === "BACKEND_MATURITY")
                          // ) ||
                          // item?.planStatus === "MATURED" ||
                          // item?.planStatus === "PENDING"
                          !item?.product?.properties?.allowsTopUp ||
                          item?.interestReceiptOption === "UPFRONT" ||
                          item?.interestReceiptOption === "BACKEND_UPFRONT" ||
                          item?.planStatus === "MATURED" ||
                          item?.planStatus === "PENDING"
                        }
                      >
                        Top Up
                      </Button>
                    </AllowAccess>
                  </div>
                  <div>
                    <AllowAccess allowedRights={["TRANSFER_INVESTMENT"]}>
                      <Button
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        onClick={() => onTransferClick(item)}
                        disabled={
                          !item?.product?.properties?.allowsTransfer ||
                          item?.planStatus === "MATURED" ||
                          item?.planStatus === "PENDING"
                        }
                      >
                        Transfer
                      </Button>
                    </AllowAccess>
                  </div>
                  <div>
                    <AllowAccess allowedRights={["WITHDRAW_INVESTMENT"]}>
                      <Button
                        onClick={() => onWithdrawalClick(item)}
                        style={{ width: "8em", display: "flex", justifyContent: "center" }}
                        color="primary"
                        className="btn-sm mt-2"
                        disabled={item?.planStatus === "PENDING"}
                      >
                        Withdraw
                      </Button>
                    </AllowAccess>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const LoginLogTable = () => {
  return (
    <table className="table table-ulogs">
      <thead className="thead-light">
        <tr>
          <th className="tb-col-os">
            <span className="overline-title">
              Browser <span className="d-sm-none">/ IP</span>
            </span>
          </th>
          <th className="tb-col-ip">
            <span className="overline-title">IP</span>
          </th>
          <th className="tb-col-time">
            <span className="overline-title">Time</span>
          </th>
          <th className="tb-col-action">
            <span className="overline-title">&nbsp;</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {loginData.map((item, idx) => {
          return (
            <tr key={idx}>
              <td className="tb-col-os">{item.browser}</td>
              <td className="tb-col-ip">
                <span className="sub-text">{item.ip}</span>
              </td>
              <td className="tb-col-time">
                <span className="sub-text">
                  {item.date} <span className="d-none d-sm-inline-block">{item.time}</span>
                </span>
              </td>
              <td className="tb-col-action">
                {item.action === true && (
                  <a
                    href="#delete"
                    onClick={(ev) => {
                      ev.preventDefault();
                    }}
                    className="link-cross mr-sm-n1"
                  >
                    <Icon name="cross"></Icon>
                  </a>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

// const dateFormatter = (props) => {
//   const newDate = new Date(props);
//   return newDate.toDateString();
// };
